"use client";
import Link from "next/link";
import { usePathname } from "next/navigation";

import useAnalytics from "@/hooks/useAnalytics";

import { NAV_ITEMS } from "./constants";
import { useMobileNavigation } from "./MobileNavigationProvider";

function MobileNavigation() {
  const pathname = usePathname();
  const { isMobileMenuOpen, setIsMobileMenuOpen } = useMobileNavigation();
  const { trackEvent } = useAnalytics();

  const isActive = (path: string) => pathname === path;
  if (!isMobileMenuOpen) {
    return null;
  }

  return (
    <div className="lg:hidden border-b border-slate-200 dark:border-slate-700 shadow-lg bg-white/60 backdrop-blur-2xl dark:bg-slate-900/60 animate-slide-down">
      <div>
        {NAV_ITEMS.map((item) => (
          <Link
            className={`
                    flex items-center gap-3 px-6 py-3 rounded-lg font-medium transition-colors
                    ${
                      isActive(item.path)
                        ? "bg-emerald-100 text-emerald-700 dark:bg-emerald-500/20 dark:text-emerald-300"
                        : "text-slate-600 hover:text-slate-900 hover:bg-slate-100 dark:text-slate-300 dark:hover:text-white dark:hover:bg-slate-800/50"
                    }
                  `}
            href={item.path}
            key={item.path}
            onClick={() => {
              setIsMobileMenuOpen(false);
              void trackEvent({ action: "Navigation Clicked", category: "navigation", label: item.label });
            }}
          >
            <item.icon className={item.color} size={18} />
            {item.label}
          </Link>
        ))}
      </div>
    </div>
  );
}

export default MobileNavigation;
